interface VirtualKeyProps {
  label: string;
  isPressed: boolean;
  class?: string;
}

export function VirtualKey(props: VirtualKeyProps) {
  return (
    <div
      class={`h-11 min-w-[44px] px-3 flex items-center justify-center rounded-lg border font-extrabold shadow-sm font-mono text-[11px] transition-all duration-75 select-none ${
        props.isPressed
          ? "bg-primary border-primary text-primary-foreground scale-[0.93] shadow-[0_0_12px_rgba(var(--accent-rgb),0.6)]"
          : "border-border/30 bg-muted/40 text-muted-foreground/80 hover:bg-muted/60"
      } ${props.class ?? ""}`}
    >
      {props.label}
    </div>
  );
}
